import { Grid, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import ProgressBar from './ProgressBar';
import quoteImage from '../../assets/quote.png'
import profilePicture from '../../assets/profile_picture.jpg'

const useStyles = makeStyles(theme => ({
  mobile: {
    marginTop: "2em",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: 'column',
    }
  },
  mobileDiv: {
    margin: "2%",
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
      width: "100%"
    }
  }
}))

function ProfileDetail(props) {
  const classes = useStyles();
  const {summary, skills} = props;
  const skillSetDetails = skills.map( (skill, ind)=> (
    <ProgressBar key={ind} {...skill}  />
  ));
  return (
    <div>
      <Grid item container justify='center' alignItems='center' className={classes.mobile}>
        <Grid item xs={4} style={{margin: '2%'}} className={classes.mobileDiv}>
          <div className='profileImageSection'>
            <img src={profilePicture} alt='profImage'/>
            <img className='quote-image' src={quoteImage} alt='quoteImage'/>
            <Typography variant='subtitle1' align='center' color='textSecondary'>{summary}</Typography>
          </div>
        </Grid>
        <Grid item xs={6} className={classes.mobileDiv}>
          {skillSetDetails}
        </Grid>
      </Grid>
    </div>
  );
}

export default ProfileDetail;